
export const CAMERAS = {
    SELFIE_NEUTRAL: 'neutralSelfie',
    SELFIE_SPECIAL: 'specialSelfie',
    DNI_FRONT: 'front',
    DNI_BACK: 'back',
}

export default CAMERAS;